import React, { useEffect } from 'react'
import './scss/contactSupportStatic.scss'

function ContactSupportStatic() {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [])
  return (
    <div className="contact-support-container">
      <div className="contact-support-content">
        <div className="illustration-section">
          <div className="envelope-illustration">
            <svg 
              className="envelope-svg"
              viewBox="0 0 47 32"
            >
              <g>
                <path d="M45.5,0h-44C0.673,0,0,0.673,0,1.5v29C0,31.327,0.673,32,1.5,32h44c0.827,0,1.5-0.673,1.5-1.5v-29 C47,0.673,46.327,0,45.5,0z M1.5,1h44C45.775,1,46,1.225,46,1.5v2.119L26.947,22.162c-1.654,1.566-4.243,1.568-5.897-0.005L1,3.611 V1.5C1,1.225,1.225,1,1.5,1z M45.5,31h-44C1.225,31,1,30.775,1,30.5V4.974l19.366,17.913c1.019,0.967,2.325,1.45,3.633,1.45 c1.309,0,2.619-0.484,3.641-1.454L46,5.014V30.5C46,30.775,45.775,31,45.5,31z"></path>
                <path d="M12.394,18.058l-5.628,5.636c-0.195,0.195-0.195,0.512,0,0.707c0.098,0.098,0.226,0.146,0.354,0.146 s0.256-0.049,0.354-0.146l5.628-5.636c0.195-0.195,0.195-0.512,0-0.707S12.589,17.862,12.394,18.058z"></path>
                <path d="M35.93,17.2c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707l6.274,6.276 c0.098,0.098,0.226,0.146,0.354,0.146s0.256-0.049,0.354-0.146c0.195-0.195,0.195-0.512,0-0.707L35.93,17.2z"></path>
              </g>
            </svg>
          </div>
        </div>
        
        <div className="text-section">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-description">
            In case you have any questions or technical issues, please email us at{' '}
            <a href="mailto:support@fwfg.com" className="email-link">
              support@fwfg.com
            </a>{' '}
            using the same email address you used to subscribe to FWFG.
          </p>
        </div>
      </div>
    </div>
  )
}

export default ContactSupportStatic